import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold font-heading text-background-50">
                韩漫大全
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-5">
              韩漫官方网址，提供最全的韩国漫画资源。无删减漫画免费在线观看，下载好看韩国漫画APP，随时随地畅享阅读体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">
              <a href="/category/remen-tuijian">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">
              热门推荐
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/2" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">我独自升级</Link></li>
              <li><Link to="/article/1" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">女神降临</Link></li>
              <li><Link to="/article/8" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">剑尊归来</Link></li>
              <li><Link to="/article/3" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">甜蜜家园</Link></li>
              <li><Link to="/article/6" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">他人即地狱</Link></li>
              <li><Link to="/article/9" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">外貌至上主义</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold font-heading text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">用户口碑</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
            <div className="mt-5">
              <p className="text-sm text-background-400 mb-1">客服邮箱</p>
              <a href="mailto:support@hanman123.com" className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer">support@hanman123.com</a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 韩漫大全 HanMan123.com - 韩国漫画在线阅读平台 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}